var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('img',{attrs:{"src":require("../../assets/logo-main.png"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"message-error"},[_vm._v("Su empresa aún no ha sido registrada.")]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.push({name: 'login'})}}},[_vm._v("Ir a página principal")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7316408e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/404.vue
// module id = null
// module chunks = 